<template>
  <div class="wrapper">
    <notifications/>
    <div class="main-content">
      <guest-navbar @headerLoginClicked="onHeaderLoginClicked" @userClicked="handleUserClicked()"/>

      <div>
        <GuestHome @dblClick="handleDblClick()"/>

        <SidebarRight
          v-click-outside="outside"
          :class="['navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400', {'open': showSideBar}]"
        >
          <transition 
            name="slide-fade" 
            mode="out-in">
            <component 
              :is="currentView" 
              @iAmNewClicked="handleIAmNewClicked"
              @backClickedFromRegister="currentView='Login'"
              @backClickedFromForgot="currentView='Login'"
              @forgotPasswordLinkClicked="currentView='Forgot'"
              @registerSuccess="onRegisterSuccess"
              @resetPasswordSuccess="onResetPasswordSuccess"
              @userVerified="onUserVerificationSuccess"
            />
          </transition>
        </SidebarRight>
      </div>
      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import GuestHome from '@/app/pages/GuestHome.vue'


import GuestNavbar from './GuestNavBar.vue';
import ContentFooter from './Footer.vue';
import SidebarRight from './SidebarRight'
import { FadeTransition } from 'vue2-transitions';

//sidebar components
import Login from '@/app/components/Login.vue'
import Another from '@/app/components/Another.vue'
import Register from '@/app/components/Register.vue'
import Verify from '@/app/components/Verify.vue'
import Forgot from '@/app/components/Forgot.vue'
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';


function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    GuestNavbar,
    ContentFooter,
    FadeTransition,
    SidebarRight,
    GuestHome,
    Login,
    Another,
    Register,
    Verify,
    Forgot
  },
  data() {
    return {
       showSideBar: false,
       currentView: 'Login',
       registrationData: null
    }
  },
  mounted () {
   if(this.$auth.isAuthenticated()) {
     this.$router.push('/projects')
   } else {
     setTimeout(() => {
      //  this.$notify({
      //     type: 'success',
      //     message: 'Please double click on white area to start a project'
      //   })

      this.$snack.success('Please double click on white area to start a project.')

    }, 5000)
   }
  },
  methods: {
    handleUserClicked () {
      this.currentView = "Another"
      this.showSideBar = true
    },

    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('scrollbar-inner');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    },
    handleDblClick() {
      this.currentView = "Login"
      this.showSideBar = true;    
      //this.$router.push('/home');
    },

    onHeaderLoginClicked () {
      this.currentView = "Login"
      this.showSideBar = true;   
    },

    handleIAmNewClicked() {
      this.currentView = "Register"
      this.showSideBar = true;    
      //this.$router.push('/home');
    },

    onRegisterSuccess (data) {
      this.currentView = "Verify"
    },

    onResetPasswordSuccess () {
      this.$snack.success('Password has been reset successfully, please login.')
      this.currentView = "Login"
    },

    onUserVerificationSuccess () {
      this.$snack.success('Account has been verified successfully, please login.')
      this.currentView = "Login"
    },


    outside() {
      if(this.showSideBar) {
        this.showSideBar = false;
      }
        
    }
  },
  
};
</script>

<style lang="scss">
  @import "~assets/sass/base/helpers/mixins";
  .w-100{
    .logo-center, .block__absolute{
      .icon-logo{
        @include animation('slideUp 2s');
        -webkit-transition-delay: 0.3s;
        -moz-transition-delay: 0.3s;
        -o-transition-delay: 0.3s;
        transition-delay: 0.3s;
      }
    }
    .block__absolute{
      @include animation('slideInLeft 2s');
    }
  }
  .slide-fade{
    &-enter{
      opacity: 0;
      // @include animation('slide-left 2s');
      transform: translateX(150px);
        .logo-center, .block__absolute{
          opacity: 0;
        }
    }
    &-enter-active{
      transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
      .logo-center{
        -webkit-transition-delay: 0.3s;
        -moz-transition-delay: 0.3s;
        -o-transition-delay: 0.3s;
        transition-delay: 0.3s;
      }
    }
    &-leave-active{
      transition: all .10s cubic-bezier(1.0, 0.5, 0.8, 1.0);
      .logo-center{
        opacity: 0;
      }
    }
    &-leave-to{
      transform: translateX(-150px);
      opacity: 0;
      .logo-center{
        opacity: 0;
      }
    }
    // .block__absolute{
    //     -webkit-transition-delay: 10s;
    //     -moz-transition-delay: 10s;
    //     -o-transition-delay: 10s;
    //     transition-delay: 10s;
    // }
  }

  // .slide-enter-active {
  //   -moz-transition-duration: 0.3s;
  //   -webkit-transition-duration: 0.3s;
  //   -o-transition-duration: 0.3s;
  //   transition-duration: 0.3s;
  //   -moz-transition-timing-function: ease-in;
  //   -webkit-transition-timing-function: ease-in;
  //   -o-transition-timing-function: ease-in;
  //   transition-timing-function: ease-in;
  // }

  // .slide-leave-active {
  //   -moz-transition-duration: 0.3s;
  //   -webkit-transition-duration: 0.3s;
  //   -o-transition-duration: 0.3s;
  //   transition-duration: 0.3s;
  //   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  //   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  //   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  //   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  // }

  // .slide-enter-to, .slide-leave {
  //   max-height: 100px;
  //   overflow: hidden;
  // }

  // .slide-enter, .slide-leave-to {
  //   overflow: hidden;
  //   max-height: 0;
  // }
</style>